import Header from './components/header';
import { Outlet } from 'react-router-dom';

const MasterLayout = () => {
  return (
    <div className=' min-h-screen  h-100 bg-background flex flex-col p-2.5 gap-2.5 '>
      <Header />
      {/* <Navbar /> */}

      {/* <Sidebar /> */}

      <main className=' flex-grow flex flex-col '>
        <Outlet />
      </main>
    </div>
  );
};

export default MasterLayout;
